export const currency = 'lei';

export const Companies = [{
  name: 'E.ON Energie România',
  companyCode: '1930'
}];

export const appName = 'EON Ajutoare';
export const backButton = 'Înapoi';
export const loginTitle = 'Ajutoare de\n încălzire';
export const loginFormLabel = 'Intră în cont';
export const loginAccountPlaceholder = 'Username sau adresa de email';
export const loginPasswordPlaceholder = 'Parola';
export const loginSubmitButton = 'Intră';
export const loginForgotPassword = 'Ai uitat parola?';
export const loginForgotPasswordChangeButton = 'Resetează parola';
export const loginForgotPasswordCloseButton = 'Închide';
export const loginForgotPasswordTitle = 'Resetează parola';
export const loginForgotPasswordTips = 'Vei primi pe email un link pentru resetarea parolei';
export const loginForgotPasswordAccountPlaceholder = 'Adresa de email';
export const termsAndConditions = 'Termeni și condiții';
export const cookies = 'Cookies';
export const dataProtection = 'Protecția datelor';
export const contact = 'Contact';
export const contactMail = 'ajutoare.myline@eon-romania.ro';
export const navBarNaturalGas = 'Gaze Naturale';
export const navBarNaturalGasAid = 'Ajutoare Gaze Naturale';
export const navBarNaturalGasAddition = 'Suplimente Gaze Naturale';
export const navBarElectricEnergy = 'Energie Electrică';
export const navBarElectricEnergyAid = 'Ajutoare Energie Electrică';
export const navBarElectricEnergyAddition = 'Suplimente Energie Electrică';
export const navBarReport = 'Rapoarte';
export const navBarPaymentReport = 'Certificare borderouri ajutoare';
export const navBarPaymentReportAdditions = 'Certificare borderouri suplimente';
export const navBarBillAids = 'Ajutoare facturate';
export const navBarBillAdditions = 'Suplimente facturate';
export const navBarPartnerExport = 'Export clienţi';
export const navBarBilledAidsHistory = 'Istoric ajutoare facturate';
export const navBarBackOfficeSearch = 'Calcul cuantum ajutor efectiv';
export const navBarMyAccount = 'Contul meu';
export const navBarSettings = 'Setări';
export const navBarSettingsBlockMonth = 'Blocare luni';
export const navBarLogout = 'Logout';
export const beneficiarySearchTitle = 'Caută un beneficiar';
export const beneficiarySearchAdditionTitle = 'Caută un supliment';
export const beneficiarySearchTips = 'Poţi căuta după cod abonat, cod loc consum sau CNP';
export const beneficiaryAdditionSearchTips = 'Poţi căuta după cod abonat, cod loc consum sau CNP';
export const beneficiarySearchButton = 'Caută';
export const beneficiarySearchError = '"{0}" este invalid';
export const beneficiarySearchClient = 'Client';
export const beneficiarySearchNaturalGas = 'Ajutoare Gaze Naturale';
export const beneficiarySearchElectricEnergy = 'Ajutoare Energie Electrică';
export const beneficiarySearchAdditionNaturalGas = 'Suplimente Gaze Naturale';
export const beneficiarySearchAdditionElectricEnergy = 'Suplimente Energie Electrică';
export const beneficiarySearchClientCode = 'Cod abonat';
export const beneficiarySearchName = 'Beneficiar';
export const beneficiarySearchAddress = 'Adresă loc consum';
export const beneficiarySearchAdditionAddress = 'Adresă loc consum';
export const beneficiarySearchCNP = 'CNP beneficiar';
export const beneficiarySearchConsumptionAddress = 'Cod loc consum';
export const beneficiarySearchAdditionFiscalNumber = 'CNP beneficiar';
export const beneficiarySearchAdditionStartDate = 'Supliment activ din luna';
export const beneficiarySearchAdditionName = 'Nume beneficiar';
export const beneficiarySearchResultsNotFound = 'Nu a fost găsit nici un rezultat pentru {0}';
export const beneficiaryAddClient = 'Client';
export const beneficiaryAddStartDateText = 'Selectează luna pentru care se acordă ajutorul';
export const beneficiaryAddAdditionStartDateText = 'Selectează luna pentru care se acordă suplimentul';
export const beneficiaryAddStartDateLabel = 'Luna din care se acordă ajutorul';
export const beneficiaryAddAdditionStartDateLabel = 'Luna din care se acordă suplimentul';
export const beneficiaryAddStartDateInfo =
  'Dacă datele (Nume și Prenume) nu coincid cu cele ale beneficiarului, le poți schimba cu ajutorul câmpurilor de mai jos';
export const beneficiaryAddBeneficiaryData = 'Date beneficiar';
export const beneficiaryAddAdditionBeneficiaryData = 'Date beneficiar';
export const beneficiaryAddPersonalData = 'Date personale';
export const beneficiaryAddPersonalDataInfo = 'Introdu datele de identificare ale beneficiarului';
export const beneficiaryAddFirstName = 'Prenume beneficiar*';
export const beneficiaryAddLastName = 'Nume beneficiar*';
export const beneficiaryAddPersonalIdentificationNumber = 'CNP beneficiar*';
export const beneficiaryAddLocalitySector = 'Sector';
export const beneficiaryAddFamilyMemberData = 'Date membri familie';
export const beneficiaryAddFamilyMemberDataInfo = 'Introdu datele legate de membrii familiei';
export const beneficiaryAddFamilyMembersNo = 'Nr. membri';
export const beneficiaryAddMemberFamilyIncome = 'Venit/ membru';
export const beneficiaryAddTotalFamilyIncome = 'Venit/ familie';
export const beneficiaryAddFinancialData = 'Date privind ajutorul aprobat';
export const beneficiaryAddAdditionFinancialData = 'Date privind suplimentul';
export const beneficiaryAddFinancialDataInfo = 'Introdu informațiile privind cuantumul ajutorului aprobat';
export const beneficiaryAddAdditionFinancialDataInfo = 'Introdu informațiile privind cuantumul suplimentului aprobat';
export const beneficiaryAddApprovalDocumentNo = 'Nr. dispoziţie primar*';
export const beneficiaryAddApprovalDocumentData = 'Data emiterii dispoziţiei (luna/zi/an)';
export const beneficiaryAddStateBudgetAmount = 'Cuantum din bugetul de stat*';
export const beneficiaryAddSeason = 'Sezon';
export const beneficiaryAddLocalBudgetAmount = 'Cuantum din bugetul local';
export const beneficiaryAddTotalAmount = 'Total';
export const beneficiaryAddSave = 'Salvează';
export const beneficiaryAddModify = 'Modifică';
export const beneficiaryAddCancel = 'Anulează';
export const beneficiaryAddDelete = 'Şterge';
export const beneficiaryAddDeletedSuccess = 'Ajutorul a fost șters cu success.';
export const beneficiaryAddStartDateError = 'Selectează luna';
export const beneficiaryAddFirstNameError = 'Adaugă prenume';
export const beneficiaryAddLastNameError = 'Adaugă nume';
export const beneficiaryAddPersonalIdentificationNumberError = 'CNP invalid';
export const beneficiaryAddFamilyMembersNoError = 'Adaugă numărul de membri';
export const beneficiaryAddMemberFamilyIncomeError = 'Adaugă venitul pe membru.';
export const beneficiaryAddTotalFamilyIncomeError = 'Adaugă venitul pe familie.';
export const beneficiaryAddApprovalDocumentNoError = 'Adaugă nr. dispoziție primar.';
export const beneficiaryAddApprovalDocumentDataError = 'Completează data.';
export const beneficiaryAddStateBudgetAmountError = 'Adaugă cuantum din bugetul de stat.';
export const beneficiaryAddLocalBudgetAmountError = 'Adaugă cuantum din bugetul local.';
export const beneficiaryAddModalConfirmHead = 'Verifică datele!';
export const beneficiaryAddModalConfirmLabel = 'Solicitatea va fi trimisă pentru:';
export const beneficiaryAddModalConfirmButtonSend = 'Trimite';
export const beneficiaryAddModalConfirmButtonCancel = 'Renunţă';
export const beneficiaryAddModalDeleteHead = 'Ştergi datele pentru luna {0}?';
export const beneficiaryAddModalDeleteButtonDelete = 'Şterge';
export const beneficiaryAddModalDeleteButtonCancel = 'Renunţă';
export const beneficiaryAddModalSuccessHead = 'Solicitarea a fost trimisă cu succes!';
export const beneficiaryAddDefaultStateAmountValue = 0;
export const beneficiaryAddNaturalGasLabel = 'Gaze naturale';
export const beneficiaryAddElectricEnergyLabel = 'Electricitate';
export const beneficiaryAddMonthIsClosed = 'Luna selectată este blocată! Nu mai sunt permise modificări';

export const beneficiaryAddSeasonSelect = [{
  value: 0,
  label:'Sezon precedent',
},
{
  value: 1,
  label:'Sezon curent',
  selected:true
}];

export const dashboardNaturalGas = 'Ajutoare Gaze Naturale';
export const dashboardElectricEnergy = 'Ajutoare Energie Electrică';
export const dashboardAdditionNaturalGas = 'Suplimente Gaze Naturale';
export const dashboardAdditionElectricEnergy = 'Suplimente Energie Electrică';
export const dashboardReport = 'Rapoarte';
export const dashboardImportBeneficiary = 'Import Beneficiari';
export const dashboardImportBeneficiaryAJPIS = 'Import Beneficiari AJPIS';
export const dashboardImportAddition = 'Import Suplimente';
export const dashboardImportAdditionAJPIS = 'Import Suplimente AJPIS';
export const dashboardExportClient = 'Export Clienţi';
export const partnerExportSubtitle = 'Exportă baza de date cu clienţii\ndin aria administrativ teritorială';
export const partnerExportButton = 'Exportă';
export const partnerExportTitle = 'Export clienţi';
export const partnerExportFileName = 'Export clienti {0}.xlsx';
export const adminPartnerExportFileName = 'Export clienti {0} {1}.xlsx';
export const partnerExportCountGn = 'Clienți gaze naturale: {0}';
export const partnerExportCountEe = 'Clienți energie electrică: {0}';
export const partnerExportCountLoading = 'Se încarcă datele despre beneficiari ...';
export const partnerExportProcessingMessage = '...se extrag datele';
export const partnerExportProcessingSubMessage = '({0} din {1} de înregistrări procesate)';
export const partnerExportExpireMessage = '(expiră la {0})';
export const partnerExportDownloadButton = 'Download';
export const partnerExportCancelButton = 'Anulează';
export const partnerExportExportIsRunning =
  'Există deja un proces activ de extragere a datelor. Anulează exportul existent înainte de a genera altul!';
export const partnerExportExportIsRunningButton = 'OK';
export const partnerExportExportCanDownload = 'Există deja un fișier generat pe care îl poți downloada. Ai nevoie de un fișier nou?';
export const partnerExportExportCanDownloadButtonYes = 'Da';
export const partnerExportExportCanDownloadButtonNo = 'Nu';
export const userAccountTitle = 'Contul meu';
export const userAccountInfo = 'Completează informaţiile de mai jos dacă doreşti să fie utilizate în antetul rapoartelor.';
export const userAccountAccountName = 'Denumire primărie';
export const userAccountSaveButton = 'Salvează';
export const userAccountAddressTitle = 'Adresă';
export const userAccountStreetLabel = 'Strada';
export const userAccountStreetNoLabel = 'Număr';
export const userAccountSignatoryReportsTitle = 'Semnatari rapoarte';
export const userAccountSignatoryReportsLabel =
  'Poţi adăuga maxim 4 persoane dacă doreşti să apară în subsolul rapoartelor în calitate de semnatari';
export const userAccountMajorLabel = 'Primar';
export const userAccountUserNameLabel = 'Nume utilizator';
export const userAccountEmailLabel = 'Email';
export const userAccountLogo = 'Emblemă';
export const userAccountUploadImage = 'Încarcă imagine';
export const userAccountCustomLabel = 'Funcţie';
export const userAccountCustomFieldLabel = 'Nume prenume';
export const userAccountOldPasswordLabel = 'Parola actuală';
export const userAccountNewPasswordLabel = 'Noua parolă';
export const userAccountConfirmPasswordLabel = 'Confirmă parola';
export const userAccountAccountNameError = 'Număr invalid';
export const userAccountCountyCodeError = 'Judeţ invalid';
export const userAccountLocalityCodeError = 'Oraş invalid';
export const userAccountStreetError = 'Strada invalidă';
export const userAccountStreetNoError = 'Număr invalid';
export const userAccountCustomFieldError = 'Nume invalid';
export const userAccountCustomLabelError = 'Funcţie invalidă';
export const userAccountUserNameError = 'Nume utilizator invalid';
export const userAccountEmailError = 'Email invalid';
export const userAccountLogoError = 'Imagine invalidă';
export const userAccountPasswordError = 'Parola nu se potriveşte';
export const userAccountPasswordCloseButton = 'Închide';
export const userAccountPasswordSaveButton = 'Salvează';
export const userAccountAddCustomField = 'Adaugă semnatar';
export const userAccountPasswordChange = 'Modifică parola';
export const userAccountLogoDeletedSuccess = 'Logo-ul a fost șters cu success.';
export const userAccountAccountUpdatedSuccess = 'Datele din cont au fost actualizate cu success.';
export const userAccountPasswordChangedSuccess = 'Parola a fost actualizată cu success.';
export const userAccountInvalidData = 'Date invalide';

export const reportTitle = 'Rapoarte';
export const reportNaturalGasCount = 'Total beneficiari gaze naturale: {0}';
export const reportElectricEnergyCount = 'Total beneficiari energie electrică: {0}';
export const reportAdditionNaturalGasCount = 'Total suplimente gaze naturale: {0}';
export const reportAdditionElectricEnergyCount = 'Total suplimente energie electrică: {0}';
export const reportSelectLabel = 'Luna din care se acordă ajutorul';
export const reportCityHallSelectLabel = 'Selectează primăria';
export const reportCityHallPlaceholder = 'Toate primăriile';
export const reportSelectError = 'Selectează luna';
export const reportTypeOptions = [
  { tooltip: 'Beneficiari de gaze naturale', label: 'Anexa 2', value: 'anexa1b' },
  { tooltip: 'Beneficiari de energie electrică', label: 'Anexa 3', value: 'anexa1c' },
  { tooltip: 'Beneficiari de gaze naturale si \n energie electrică', label: 'Anexa 9', value: 'anexa9' },
  { tooltip: 'Suplimente de gaze naturale', label: 'Anexa 15', value: 'anexa15' },
  { tooltip: 'Suplimente de energie electrică', label: 'Anexa 16', value: 'anexa16' },
  { tooltip: 'Export beneficiari', label: 'Export \n beneficiari', value: 'exportBeneficiary' },
  { tooltip: 'Export suplimente', label: 'Export \n suplimente', value: 'exportSupliment' }
];
export const reportSubmitFormatOption1 = 'Generează raport PDF';
export const reportSubmitFormatOption2 = 'Generează raport Excel';
export const reportJobModalTitle = 'Porneşte un job pentru {0}';
export const reportJobModalBody = 'Te rugăm să nu închizi această pagină până când fișierul nu a fost descărcat.';
export const reportJobModalButtonClose = 'Închide';
export const reportJobModalButtonSubmit = 'Generează raport';
export const reportJobErrorMessage = 'A intervenit o problemă. Te rugăm să reîncerci.';
export const reportJobCanceledMessage = 'Exportul a fost anulat.';
export const reportJobReadyMessage = 'Exportul este pregătit.';

export const fileImportTitle = 'Import fişier';
export const fileImportAJPISTitle = 'Import fişier ajutoare Ajpis';
export const fileImportAdditionTitle = 'Import fişier suplimente';
export const fileImportAdditionAJPISTitle = 'Import fişier suplimente Ajpis';
export const fileImportTips = 'Încarcă un fişier de tip .xlsx cu datele beneficiarilor';
export const fileImportSubTipsLink = 'Template fişier pentru import';
export const fileImportNomenclatureTipsLink = 'Nomeclator localităţi';
export const fileImportStep1FileUploadDrag = 'Trage fişierul aici sau \n Alege fişier';
export const fileImportStep1UploadButton = 'Încarcă fişier';
export const fileImportStep1DeleteFile = 'Şterge fişierul';
export const fileImportStep1FileUploadError = 'Fişier invalid';
export const fileImportStep2QuitButton = 'Renunţă';
export const fileImportStep2LoadingFile = '...se încarcă fişierul';
export const fileImportStep2ValidateFile = '...se verifică datele';
export const fileImportStep2ValidatedFile = 'Verificare finalizată';
export const fileImportStep2LoadedFile = 'Încărcare finalizată';
export const fileImportStep3ImportButton = 'Importă';
export const fileImportStep3QuitButton = 'Renunţă';
export const fileImportStep3TotalLabel = 'Total înregistrări:';
export const fileImportStep3NewLabel = 'Beneficiari noi:';
export const fileImportStep3ChangedLabel = 'Modificări:';
export const fileImportStep3StopLabel = 'Încetări:';
export const fileImportTemplateName = 'template';
export const fileImportNomenclatureName = 'nomenclator';
export const fileImportStep3CorrectRecords = 'Înregistrări corecte:';
export const fileImportStep3IncorrectRecords = 'Înregistrări incorecte:';
export const fileImportStep3ImportCorrectRecordsButton = 'Importă înregistrările corecte';
export const fileImportStep3ImportNewFileButton = 'Importă fişier nou';
export const fileImportStep3DetectedErrors = 'Erorile detectate';
export const fileImportStep3ErrorExportButton = 'Exportă erorile';
export const fileImportStep3CorrectRecordsSuccessImport = 'Importate cu succes';
export const fileImportStep3TableHeadConsumerCode = 'Cod abonat';
export const fileImportStep3TableHeadBeneficiary = 'Beneficiar';
export const fileImportStep3TableHeadBeneficiaryPersonalIdentificationNumber = 'CNP';
export const fileImportStep3TableHeadApprovalDocumentNo = 'Număr dispoziţie';
export const fileImportStep3TableHeadStateBudgetAmount = 'Cuantum buget stat';
export const fileImportStep3TableHeadAidMonth = 'Luna de ajutor';
export const fileImportStep3TableHeadConsumptionPointAddress = 'Adresă';
export const fileImportStep3TableHeadConsumptionPointCode = 'Cod loc consum';
export const fileImportStep3TableHeadErrorDescription = 'Descriere eroare';
export const fileImportStep3ModalTitleLessThen20 = 'Vor fi importate {0} înregistrări';
export const fileImportStep3ModalTitleOne = 'Va fi importată o înregistrare';
export const fileImportStep3ModalTitle = 'Vor fi importate {0} de înregistrări';
export const fileImportStep3ModalImport = 'Importă';
export const fileImportStep3ModalExit = 'Renunţă';
export const fileImportErrorFileName = 'Erori import ';
export const billAdditionsTitleImportFile = 'Import fişier suplimente facturate';

export const billAidsTitleImportFile = 'Import fişier ajutoare facturate';
export const billAidsImportFileName = '{0}';
export const billAidsImportFileDate = 'Importat la: {0}';
export const billAidsConfirmInfo = 'Confirmă importul pentru a putea fi accesat\nde primării, CRC-uri și AJPIS-uri';
export const billAidsConfirmButton = 'Confirmă';
export const billAidsImportCancelButton = 'Anulează';
export const billAidsDeleteModalTitle = 'Confirmă ștergerea importului.';
export const billAidsDeleteModalDescription = '';
export const billAidsDeleteModalInfo = 'Datele vor fi sterse definitiv din sistem.';
export const billAidsDeleteModalConfirmButton = 'Confirmă';
export const billAidsDeleteModalCancelButton = 'Renunţă';

export const billAidsFinalizeModalTitle = 'Confirmă finalizarea importului';
export const billAidsFinalizeModalDescription =
  'După confirmare datele importate vor fi disponibile primăriilor, CRC-urilor și Agențiilor Județene.';
export const billAidsFinalizeModalInfo = 'Nu mai poți șterge datele!';
export const billAidsFinalizeModalConfirmButton = 'Confirmă';
export const billAidsFinalizeModalCancelButton = 'Renunţă';

export const billAidsTips =
  'Încarcă un fişier de tip .xlsx cu datele beneficiarilor şi cuantumul efectiv al acestora (borderou de decontări)';
export const billAidsStep1FileUploadDrag = 'Trage fişierul aici sau \n Alege fişier';
export const billAidsStep1UploadButton = 'Încarcă fişier';
export const billAidsStep1DeleteFile = 'Şterge fişierul';
export const billAidsStep1FileUploadError = 'Fişier invalid';
export const billAidsStep2QuitButton = 'Renunţă';
export const billAidsStep2LoadingFile = '...se încarcă fişierul';
export const billAidsStep2ValidateFile = '...se verifică datele';
export const billAidsStep2ValidatedFile = 'Verificare finalizată';
export const billAidsStep2LoadedFile = 'Încărcare finalizată';
export const billAidsStep3QuitButton = 'Renunţă';
export const billAidsStep3ImportButton = 'Importă';
export const billAidsStep3TotalLabel = 'Total înregistrări: {0}';
export const billAidsStep3DecontLabel = 'Decont lunar {0}: {1} înregistrări';
export const billAidsStep3CorrectionsLabel = 'Corecţii {0}: {1} înregistrări';
export const billAidsStep3CorrectRecords = 'Înregistrări corecte: {0}';
export const billAidsStep3IncorrectRecords = 'Înregistrări incorecte: {0}';
export const billAidsStep3FileContainErrors = 'Fişierul conţine erori!';
export const billAidsStep3ErrorExportButton = 'Exportă erorile';
export const billAidsStep3ErrorQuantumToBig = 'Cuantum efectiv mai mare decât cuantum aprobat: {0}';
export const billAidsStep3ErrorAidNotFound = 'Ajutorul nu există';
export const billAdditionsStep3ErrorAdditionNotFound = 'Suplimentul nu există';
export const billAidsStep3ErrorRefundToBig = 'Restituire mai mare decât decontat: {0}';
export const billAidsStep3ErrorAidExist = 'Beneficiarul are duplicate: {0}';
export const billAidsStep3SuccessMessage = 'Verificarea datelor s-a efectuat cu succes!';
export const billAidsStep4ImportButton = 'înapoi';
export const billAidsStep4SuccessMessage = 'Importul s-a efectuat cu succes!';
export const billAidsStep4SuccessMessageComplete = 'Datele au fost importate cu success.';
export const billAidsErrorFileName = 'Errori import ';
export const associationAdministrationTableHeadName = 'Nume';
export const associationAdministrationTableHeadPersonalIdentificationNumber = 'CNP';
export const associationAdministrationTableHeadQuantum = 'Cuantum';
export const associationAdministrationTableHeadApprovalDocumentNo = 'Dispoziţie';
export const associationAdministrationTableHeadMembers = 'Membri';
export const associationAdministrationTableHeadMemberIncome = 'Venit/membru';
export const associationAdministrationTableHeadConsum = 'Consum';
export const associationAdministrationTableHeadEfectiveQuantum = 'Cuantum efectiv';
export const associationAdministrationTableSave = 'Salvează';
export const associationAdministrationTableTotal = 'Total';
export const associationAdministrationTitle = 'Administratori Asociaţii';
export const associationAdministrationInfo =
  'Talking chamber as shewing an it minutes. Trees fully of blind do. Exquisite favourite at do extensive listening. Improve up musical welcome he. Gay attended vicinity prepared now diverted. Esteems it ye sending reached as. Longer lively her design settle tastes advice mrs off who.';
export const associationAdministrationMonthError = 'Lună invalidă';
export const adminBlockMonthTitle = 'Blocare luni';
export const adminBlockMonthInfo =
  'Blochează introducerea şi modificarea ajutoarelor de către primării \n(userii backoffice și admin pot introduce/modifica ajutoare şi pentru lunile blocate) ';
export const adminBlockMonthClosedMonth = 'Luna este blocată';
export const adminBlockMonthOpenMonth = 'Luna este deschisă';
export const adminBlockMonthBlockButton = 'Blochează';
export const adminBlockMonthUnblockButton = 'Deblochează';
export const adminBlockMonthCloseButton = 'Renunţă';
export const adminBlockMonthBlockModalTitle = 'Blochezi luna {0}?';
export const adminBlockMonthUnblockModalTitle = 'Deblochezi luna {0}?';
export const adminBlockMonthBlockModalInfo = 'Introducerea de ajutoare pentru luna {0} nu va mai fi permisă!';
export const adminBlockMonthUnblockModalInfo = 'Introducerea de ajutoare pentru luna {0} va fi permisă!';

export const adminExportBeneficiaryTitle = 'Export clienţi';
export const adminExportBeneficiaryInfo = 'Exportă baza de date cu clienţii din aria administrativ teritorială';
export const adminExportBeneficiaryNaturalGasBeneficiary = 'Clienți gaze naturale: {0}';
export const adminExportBeneficiaryElectricEnergyBeneficiary = 'Clienți energie electrică: {0}';
export const adminExportAdditionNaturalGasBeneficiary = 'Suplimente gaze naturale: {0}';
export const adminExportAdditionElectricEnergyBeneficiary = 'Suplimente energie electrică: {0}';
export const adminExportBeneficiaryExportButton = 'Exportă';
export const adminExportBeneficiaryFileName = 'Export';

export const paymentsReportsArchiveModalTitle = 'Descarcă Arhiva Borderouri';
export const paymentsReportsArchiveModalDescription = '';
export const paymentsReportsArchiveModalMonthLabel = 'Selectează luna din care se generează arhiva';
export const paymentsReportsArchiveModalButtonSubmit = 'Descarcă';
export const paymentsReportsArchiveModalButtonCancel = 'închide';


export const cityHallStatisticsModalTitle = 'Descarcă fișier statistică primării';
export const cityHallStatisticsModalDescription = '';
export const cityHallStatisticsModalMonthLabel = 'Selectează luna din care se generează fișierul';
export const cityHallStatisticsModalButtonSubmit = 'Descarcă';
export const cityHallStatisticsModalButtonCancel = 'închide';

export const paymentsReportsTitle = 'Certificare borderouri ajutoare';
export const paymentsReportsAdditionTitle = 'Certificare borderouri suplimente';
export const paymentsReportsUnavailableData = 'Nu există date disponibile';
export const paymentsReportsSelectCityHall = 'Selectează primăria';
export const paymentsReportsSelectUtility = 'Selectează utilitatea';
export const paymentsReportsSelectMonth = 'Selectează luna';
export const paymentsReportsSelectReimbursementType = 'Selectează tip decont';
export const paymentsReportsSummaryReports = 'Sumar borderou';
export const paymentsReportsArchiveButton = 'Descarcă Arhiva Borderouri';
export const paymentsCityHallStatisticsButton = 'Statistică Fișiere Primării';
export const paymentsCityHallStatisticsFileName = 'Statistica Fisiere Primarii {0}';
export const paymentsReportsImportButton = 'Importă borderou certificat';
export const paymentsReportsNaturalGas = 'Gaze naturale';
export const paymentsReportsElectricEnergy = 'Electricitate';
export const paymentsReportsInitialTitle = 'Decont lunar:';
export const paymentsReportsRecalculationTitle = 'Recalculări:';
export const paymentsReportsSkipedTitle = 'Beneficiari omişi:';
export const paymentsReportsBeneficiaryCount = '({0} beneficiari)';
export const paymentsReportsTotal = 'Total:';
export const paymentsReportsDownloadCentralizator = 'Descarcă centralizatorul';
export const paymentsReportsDownloadReportType = { ee: 'Energie Electrică', gn: 'Gaze Naturale' };
export const paymentsReportsDownloadReportTypeNormal = 'Anexa';
export const paymentsReportsDownloadReportTypeAdmin = 'Anexa 25 {0}';
export const paymentsReportsDownloadLabel = 'Descarcă documentele';
export const paymentsReportsDownloadPDF = 'PDF';
export const paymentsReportsDownloadXLS = 'Excel';
export const paymentsReportsDownloadButton = 'Descarcă Borderou';
export const paymentsReportsDownloadButtonGN = 'Borderou GN';
export const paymentsReportsDownloadButtonEE = 'Borderou EE';
export const paymentsReportsDownloadFileName = 'Borderouri {2} {0}-{1}';
export const paymentsReportsDownloadFileNameAidsGN = 'Ajutoare Gaze Naturale';
export const paymentsReportsDownloadFileNameAidsEE = 'Ajutoare Energie Electrică';
export const paymentsReportsDownloadFileNameAdditionsGN = 'Suplimente Gaze Naturale';
export const paymentsReportsDownloadFileNameAdditionsEE = 'Suplimente Energie Electrică';

export const paymentReportCRCSelectLabel = 'Selectează CRC';
export const paymentReportCRCPlaceholder = 'Toate CRC-urile';
export const paymentReportCountySelectLabel = 'Selectează Județul';
export const paymentReportCountyPlaceholder = 'Toate Județele';

export const paymentsReportsImportTitle = 'Import borderou certificat ajutoare';
export const paymentsReportsImportTitleAddition = 'Import borderou certificat suplimente';

export const paymentsReportsImportSubtitle = 'Încarcă borderoul certificat, în format PDF';
export const paymentsReportsImportCompanyLabel = 'Încarcă borderoul pentru:';
export const paymentsReportsImportUploadMessage = '...se încarcă';
export const paymentsReportsImportFileUploadError = 'Fişier invalid';
export const paymentsReportsImportFileUploadDrag = 'Trage fişierul aici sau \n Alege fişier';
export const paymentsReportsImportFileSuccess = 'Fișierul a fost importat cu success.';
export const paymentsReportsImportDeleteFile = 'Şterge fişierul';
export const paymentsReportsImportUploadButton = 'Încarcă fişier';
export const paymentsReportsImportModalTitle = 'Confirmă certificarea cuantumului efectiv total';
export const paymentsReportsImportModalMessage =
  'Prin importul borderoului confirmi certificarea valorii totale a cuantumului efectiv pentru:';
export const paymentsReportsImportModalCompany = 'Furnizor:';
export const paymentsReportsImportModalCityHall = 'Primărie:';
export const paymentsReportsImportModalMonth = 'Lună solicitare decont:';
export const paymentsReportsImportModalValue = 'Valoare totală cuantum efectiv:';
export const paymentsReportsImportModalButtonSave = 'Confirmă';
export const paymentsReportsImportModalButtonCancel = 'Renunţă';
export const paymentsReportsCanNotUploadFile = 'Nu există date importate pentru această primarie.';

export const resetPasswordTitle = 'Ajutoare de\n încălzire';
export const resetPasswordFormLabel = 'Resetează parola';
export const resetPasswordGoToLogin = 'Înapoi la login';
export const resetPasswordPasswordPlaceholder = 'Parola';
export const resetPasswordConfirmPasswordPlaceholder = 'Confirmă parola';
export const resetPasswordChangeButton = 'Resetează parola';
export const resetPasswordInvalidToken = 'Token invalid';
export const resetPasswordInvalidPassword = 'Te rugăm să verifici parola';

export const contactModalTitle = 'Contact';
export const contactModalEmailLabel = 'Email:';
export const contactModalEmail = 'ajutoare.myline@eon-romania.ro';
export const contactModalPhoneLabel = 'Telefon:';
export const contactModalPhone = '0365 423 779';
export const contactModalFaxLabel = 'Fax:';
export const contactModalFax = '0265 200 367';
export const contactModalPostalLabel = 'Poștă:';
export const contactModalPostal = 'OP 1, CP 10, Târgu Mureş';
export const contactModalClose = 'Închide';

export const associationAidsNotExist = 'Nu există niciun beneficiar adăugat pe acest loc de consum';
export const associationAidsAddButton = 'Adaugă beneficiar';

export const backOfficeSearchTitle = 'Caută o asociaţie';
export const backOfficeSearchTips = 'Poţi căuta după cod abonat, cod loc consum sau CNP';
export const backOfficeSearchButton = 'Caută';
export const backOfficeSearchError = '"{0}" este invalid';
export const backOfficeSearchClient = 'Client';
export const backOfficeSearchClientCode = 'Cod abonat';
export const backOfficeSearchAddress = 'Adresă loc consum';
export const backOfficeSearchConsumptionAddress = 'Cod loc consum';
export const backOfficeSearchResultsNotFound = 'Nu a fost găsit nici un rezultat pentru {0}';
export const backOfficeSearchAids = 'Ajutoare';
export const backOfficeSearchAdditions = 'Suplimente';

export const backOfficeAssociationTitle = 'Date beneficiari';
export const backOfficeAssociationTips = 'Informaţii privind beneficiarii şi cuantumurile ajutoarelor aprobate';
export const backOfficeAssociationDropDownLabel = 'Luna din care se acordă ajutorul';
export const backOfficeAssociationButton = 'Anexa 9';
export const backOfficeAssociationTabelHeaderName = 'Beneficiar';
export const backOfficeAssociationTabelHeaderCNP = 'CNP beneficiar';
export const backOfficeAssociationTabelHeaderAmount = 'Cuantum ajutor';
export const backOfficeAssociationTabelHeaderApprovalDocumentNo = 'Număr dispoziţie';
export const backOfficeAssociationTabelHeaderMembersNo = 'Număr membri';
export const backOfficeAssociationTabelHeaderMemberFamilyIncome = 'Venit/membru';
export const backOfficeAssociationAidsNotExist = 'Nu există niciun beneficiar adăugat pe luna {0}';

export const backOfficeAssociationAdditionTips = 'Informaţii privind beneficiarii şi cuantumurile suplimentelor aprobate';
export const backOfficeAssociationAdditionDropDownLabel = 'Luna din care se acordă suplimentul';
export const backOfficeComputationAdditionTitle = 'Calcul cuantum supliment efectiv';
export const backOfficeComputationAdditionAddTabelAprovedAmount = `Cuantum supliment aprobat (${currency})`;
export const backOfficeComputationAdditionAddTabelEffectiveAmount = `Cuantum supliment efectiv (${currency})`;

export const backOfficeComputationTitle = 'Calcul cuantum ajutor efectiv';
export const backOfficeComputationTips = 'Introdu consumurile defalcate pe beneficiari şi calculează cuantumul efectiv';
export const backOfficeComputationComputationAnnex = 'Anexe calculate';
export const backOfficeComputationComputationAnnexPeriod = 'Perioada: {0} - {1}';
export const backOfficeComputationComputationAnnexConsumption = `Consum: {0} ${currency}`;
export const backOfficeComputationComputationAnnexAmount = `Cuantum efectiv: {0} ${currency}`;
export const backOfficeComputationComputationAnnexDownload = 'Anexa 9';
export const backOfficeComputationAddPeriod = 'Perioadă consum';
export const backOfficeComputationAddPeriodTips = 'Completează perioada pentru care vrei să introduci consumurile';
export const backOfficeComputationAddFrom = 'De la (luna/zi/an)';
export const backOfficeComputationAddTo = 'Până la (luna/zi/an)';
export const backOfficeComputationAddPrice = `Preţ (${currency}/kWh)`;
export const backOfficeComputationAddTabelBeneficiary = 'Beneficiar';
export const backOfficeComputationAddTabelCNP = 'CNP beneficiar';
export const backOfficeComputationAddTabelAprovedAmount = `Cuantum ajutor aprobat (${currency})`;
export const backOfficeComputationAddTabelConsumption = `Consum (${currency})`;
export const backOfficeComputationAddTabelEffectiveAmount = `Cuantum ajutor efectiv (${currency})`;
export const backOfficeComputationAddSave = 'Salvează';
export const backOfficeComputationAddEdit = 'Editează';
export const backOfficeComputationAddCancel = 'Renunţă';
export const backOfficeComputationAddFromError = 'Data minimă este {0}';
export const backOfficeComputationAddToError = 'Data maximă este {0}';
export const backOfficeComputationAddPriceError = 'Preţul trebuie setat';
export const backOfficeComputationAddConsumptionPointError = 'Punctul de consum nu este valid.';
export const backOfficeComputationAddConsumptionPointIntervalError = 'Intervalul nu este valid.';
export const backOfficeComputationModalTitle = 'Perioada de facturare';
export const backOfficeComputationModalTips = 'Poţi genera anexa pe o perioadă diferită de perioada consumului';
export const backOfficeComputationModalButtonGenerate = 'Anexa';
export const backOfficeComputationModalButtonCancel = 'Renunţă';
export const backOfficeComputationModalWarningTitle = 'Ești sigur că vrei să adaugi factura de la data {0}?. Prima zi disponibilă este {1}';
export const backOfficeComputationModalWarningButtonContinue = 'Continuă';
export const backOfficeComputationModalWarningButtonCancel = 'Renunţă';

export const billedAidsHistoryTitle = 'Istoric ajutoare efective';
export const billedAidsHistorySearchLabel = 'Caută beneficiar';
export const billedAidsHistorySearchPlaceholder = 'CNP';
export const billedAidsHistorySearchButton = 'Caută';
export const billedAidsHistoryInvalidCNP = 'CNP-ul introdus nu este valid.';
export const billedAidsHistoryTabelBudgetAmount = 'Cuantum ajutor aprobat';
export const billedAidsHistoryTabelMonth = 'Luna de ajutor';
export const billedAidsHistoryTabelEffectiveBudgetAmount = 'Cuantum ajutor efectiv';
export const billedAidsHistoryTabelDecontMonth = 'Lună solicitare decont';
export const billedAidsHistoryTabelDecontType = 'Tip decont';
export const billedAidsHistoryStatus = {
  initial: 'Decont lunar',
  omis: 'Omis',
  recalculat: 'Recalculare'
};

export const select = 'Selectează';
export const or = 'sau';
export const Months: Month.IMonths = {
  '01': 'Ianuarie',
  '02': 'Februarie',
  '03': 'Martie',
  '04': 'Aprilie',
  '05': 'Mai',
  '06': 'Iunie',
  '07': 'Iulie',
  '08': 'August',
  '09': 'Septembrie',
  '10': 'Octombrie',
  '11': 'Noiembrie',
  '12': 'Decembrie'
};
export const Utilities = {
  'EE': 'Electricitate',
  'GN': 'Gaze naturale'
};
export const Errors: Error.IApiError = {
  '401': 'Invalid Eon-Fast-User-Token',

  '1001': 'Invalid data type.',
  '1002': 'Account is not found',
  '1003': 'Missing mandatory fields',
  '1004': 'Missing or wrong request body',
  '1005': 'Invalid parameter data type',
  '1006': 'Invalid account Id',
  '1007': 'Invalid account Type Id',
  '1008': 'Email invalid',
  '1009': 'Parolă invalidă',
  '1010': 'Email Address already in use!',
  '1011': 'Account name is already taken!',
  '1012': 'Account name is mandatory!',
  '1013': 'Invalid credentials.',
  '1014': 'Loc de consum invalid',
  '1015': 'Beneficiarul nu a fost găsit',
  '1016': 'Cuantum invalid din bugetul de stat',
  '1017': 'Beneficiarul există deja',
  '1018': 'Venitul pe membru este invalid',
  '1019': 'Venitul pe familie este invalid',
  '1020': 'Invalid aid type',
  '1021': 'Cod abonat invalid',
  '1022': 'Locul de consum nu a fost găsit',
  '1023': 'Invalid search parameters',
  '1024': 'Beneficiarul există deja pe alt loc de consum',
  '1025': 'CNP invalid',
  '1026': 'Invalid utility type. Value must be \'ee\' for electricity or \'gn\' for gas',
  '1027': 'Cuantum invalid din bugetul local',
  '1028': 'Număr dispoziție invalid',
  '1029': 'Partner write error',
  '1030': 'Not found localities for user',
  '1031': 'Error retrieving the partners list for the given localities',
  '1032': 'Lună ajutor invalidă',
  '1033': 'Invalid report format',
  '1034': 'Error on retriving partner data',
  '1035': 'Error on retriving correct partner data',
  '1036': 'City Hall Logo error',
  '1037': 'Invalid content type. Content type must be png or jpeg',
  '1038': 'Approved aid write error',
  '1039': 'Aid range is not found',
  '1040': 'Partner code and consumption point code must match',
  '1041': 'Personal identification number can not be null',
  '1042': 'Aid Import is not found',
  '1043': 'No partner found for account',
  '1044': 'Template write error',
  '1045': 'Month is not yyyyMM',
  '1046': 'Month blocked is invalid',
  '1047': 'CNP duplicat',
  '1048': 'Invalid account type',
  '1049': 'Invalid import',
  '1050': 'Beneficiaries write error',
  '1051': 'Luna este blocată',
  '1052': 'Error on importing aids file.',
  '1053': 'Error on validating imported aids file.',
  '1054': 'Invalid consumption Point Interval',
  '1055': 'Aid consumption not found',
  '1056': 'Invalid file ID',
  '1057': 'Invalid file name',
  '1058': 'File already exists',
  '1059': 'Error getting documents',
  '1060': 'Partner Export',
  '1061': 'Invalid Partner Export',
  '1062': 'Document donwload error',
  '1063': 'Export Partner Already Running',
  '1064': 'Export Partner Job Cancel Error',
  '1065': 'Partner Export not running!',
  '1066': 'Email Server Error',
  '1067': 'Token email error',
  '1068': 'Error blocking month',
  '1069': 'Fișierul trebuie să conțină doar un sheet',
  '1071': 'Această modificare nu mai este permisă. Datele au fost transferate în sistemul de facturare.',
  '1086': 'Ajutorul a fost deja setat pentru acest loc de consum',
  '1087': 'Invalid addition type',
  '1091': 'Addition partner is not ok, Cnp is not ok',
  '1089': 'Aid already exist on different consumption point',
  '1088': 'Addition duplicate',
  '1090': 'Addition exist for month and partner code',
  '1092': 'Invalid addition month',

  default: 'Default error message'
};

export const ErrorsTips: Error.IErrorTips = {
  ...Errors,
  '1014': 'Codul locului de consum trebuie să fie număr din 10 caractere şi să înceapă cu cifrele 50.',
  '1037':
    'Codul locului de consum nu aparţine clientului selectat. Motiv posibil: clientul a reziliat contractul de furnizare pentru acest loc de consum sau s-a efectuat transcrierea contractului de furnizare pe altă persoană.'
};
